var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scatterplot"},[(_vm.tracks.length === 0)?_c('div',{staticStyle:{"width":"70%","margin":"10px","background":"#ebebeb","padding":"20px"}},[_vm._v(" Select genes and data types on the left to generate a scatterplot. ")]):_vm._e(),_c('div',{attrs:{"id":_vm.divId}})])
}
var staticRenderFns = []

export { render, staticRenderFns }